import { actions as matActions, selectors as matSelectors } from './Mat/matSlice';
import { actions as matCoordsActions, selectors as matCoordsSelectors } from './matCoordsSlice';
import { MAT_NAME, MAT_COORDS_NAME } from './matConfigs';

const sliceMap = {
    [MAT_NAME]: { actions: matActions, selectors: matSelectors },
    [MAT_COORDS_NAME]: { actions: matCoordsActions, selectors: matCoordsSelectors },
};

export const getBoardSlice = (configId) => sliceMap[configId];
